import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // Use smooth scrolling
        try {
            // First try the modern way with smooth behavior
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            
            // Then try scrolling the document with smooth behavior
            document.documentElement.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            
            // Finally try scrolling the root element
            const root = document.getElementById('root');
            if (root) {
                root.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }
        } catch (error) {
            // Fallback to instant scroll if smooth scrolling is not supported
            try {
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
                const root = document.getElementById('root');
                if (root) {
                    root.scrollTop = 0;
                }
            } catch (e) {
                
            }
        }
    }, [location]);

    return null;
};

export default ScrollToTop;
